import { endOfWeek, startOfWeek } from 'date-fns'
import { createContext, useContext, useState } from 'react'

const initialState: PlannerContextState = {
  selectedDate: new Date(),
  startWeekDate: startOfWeek(new Date()),
  endWeekDate: endOfWeek(new Date()),
}
interface PlannerContextState {
  endWeekDate: Date | null
  selectedDate: Date
  startWeekDate: Date | null
}

interface PlannerContextType extends PlannerContextState {
  setDate: (date: Date) => void
}

export const PlannerContextStore = createContext<PlannerContextType | undefined>(undefined)

export const PlannerContextProvider = ({ children }) => {
  const [plannerState, setPlannerState] = useState(initialState)

  const setDate = (date: Date) => {
    setPlannerState({
      selectedDate: date,
      startWeekDate: startOfWeek(date),
      endWeekDate: endOfWeek(date),
    })
  }

  return (
    <PlannerContextStore.Provider
      value={{
        setDate,
        ...plannerState,
      }}
    >
      {children}
    </PlannerContextStore.Provider>
  )
}

export const usePlannerContext = () => {
  const context = useContext(PlannerContextStore)
  if (context === undefined) {
    throw new Error('usePlannerContext must be used within a PlannerContextProvider')
  }
  return context
}

export default PlannerContextProvider
